import React, { useCallback, useEffect, useState } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { FilterChip } from './FilterChip';
import { NoResultsFilterChip } from './FilterChip/NoResultsFilterChip';
import { useFocusManager } from './hooks/useFocusManager';
import {
  GetUpdatedSearch,
  Log,
  SearchFacetWithAppliedTerms,
  SearchModification,
  SearchSummary
} from 'Src/types';
import { CHIP_ROLE, TRACKING_EVENTS } from '../constants';
import { HorizontalFilters } from '../styles';
interface BaseFilterChipsProps {
  appliedCount: number;
  facets: SearchFacetWithAppliedTerms[];
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
  searchSummary: SearchSummary;
  noResults: boolean;
}

type FilterChipsProps = BaseFilterChipsProps & RouteComponentProps;

export const FilterChips = withRouter(
  ({
    appliedCount,
    facets,
    noResults,
    getUpdatedSearch,
    history,
    log,
    searchSummary
  }: FilterChipsProps) => {
    const [activeChipIndex, setActiveChipIndex] = useState(0);

    const { 'aria-orientation': ariaOrientation, onKeyDown } = useFocusManager({
      itemElementRole: CHIP_ROLE,
      itemParentRole: 'toolbar',
      orientation: 'horizontal'
    });

    const ChipComponent = noResults ? NoResultsFilterChip : FilterChip;

    const handleUpdateSearch = useCallback(
      (modifications: SearchModification[]): void => {
        log(TRACKING_EVENTS.MODIFY_FILTER, {
          modifications
        });
        history.push(getUpdatedSearch(modifications));
      },
      [getUpdatedSearch, history, log]
    );

    useEffect(() => {
      setActiveChipIndex(0);
    }, [appliedCount]);

    return (
      <HorizontalFilters
        role="toolbar"
        aria-orientation={ariaOrientation}
        onKeyDown={onKeyDown}
        tabIndex={-1}
        onBlur={() => setActiveChipIndex(0)}
      >
        {facets.map((facet, index) => (
          <ChipComponent
            key={facet.field}
            activeChip={activeChipIndex}
            facet={facet}
            updateSearch={handleUpdateSearch}
            index={index}
            log={log}
            onFocus={() => setActiveChipIndex(index)}
            searchSummary={searchSummary}
          />
        ))}
      </HorizontalFilters>
    );
  }
);
